import { useCallback } from "react";
import { Button } from "@mui/material";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";

import { IWaitingRoomsGroup } from "src/Pages/Company/Pending/PendingBenefits/types";
import { useMassAccept } from "src/Pages/Company/Pending/PendingBenefits/query";
import { useSelectedRows } from "src/Pages/Company/Pending/PendingBenefits/SelectedRowsProvider/hooks";

export const AcceptSalaryDeduction = ({
  waitingRoomsGroup,
}: {
  waitingRoomsGroup: IWaitingRoomsGroup;
}) => {
  const { isPending, mutate } = useMassAccept();

  const { resetSelection } = useSelectedRows();

  const handleSalaryDeductionAccept = useCallback(() => {
    mutate(
      {
        documents: [waitingRoomsGroup.groupId],
        waitingRooms: [],
      },
      {
        onSuccess: () => {
          dynamicNotification(__("Pomyślnie zaakceptowano zgodę"));
        },
        onError: () => {
          dynamicNotification(__("Nie udało się zaakceptować zgody"), "error");
        },
        onSettled: () => {
          resetSelection();
        },
      }
    );
  }, [mutate, resetSelection, waitingRoomsGroup.groupId]);

  return (
    <Button
      size="small"
      variant="outlined"
      disabled={waitingRoomsGroup.salaryDeductionAccepted}
      loading={isPending}
      onClick={handleSalaryDeductionAccept}
      sx={{ minWidth: "105px" }}
    >
      {__("Akceptuj")}
    </Button>
  );
};
